import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class NewsSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false,
            cellSelector: '.news-list__item',
            cellAlign: 'left',
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        if (document.body.clientWidth < 992 ) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Slider des actus');
        } else {
            // console.log('No slider des actus');
        } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth < 992 ) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize mobile');
        } else {
            this._destroy();
            // console.log('No slider actus');
        }
    }
}

export default NewsSlider;
